import { render, staticRenderFns } from "./HotelDashboard.vue?vue&type=template&id=cb36e11e&scoped=true"
import script from "./HotelDashboard.vue?vue&type=script&lang=js"
export * from "./HotelDashboard.vue?vue&type=script&lang=js"
import style0 from "./HotelDashboard.vue?vue&type=style&index=0&id=cb36e11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb36e11e",
  null
  
)

export default component.exports